import React from 'react';
import ReactDOM from 'react-dom/client';
import '@repo/ui/styles/globals.css';
import './styles/atrium.css';
import { App } from './app';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
